import React, { useState } from 'react'
import {
    Table,
    OverlayTrigger,
} from 'react-bootstrap'
import FeatherIcon from 'feather-icons-react';
import { Link } from 'react-router-dom';
import CustomersLodingSkeleton from './table__loadingSkeleton'
import { renderTooltipDelete } from '../tooltips/Customers__Tooltips'
import Moment from 'react-moment';
import DeleteCustomer from 'components/Customers/Pages/EditCustomer/DeleteCustomer';

export default function CustomerTable(props) {
    const [deleteCustomer, setDeleteCustomer] = useState(null)

    return (
        <React.Fragment>
            {deleteCustomer && <DeleteCustomer
                show={!(!deleteCustomer)}
                closeModal={() => { setDeleteCustomer(null) }}
                user_id={deleteCustomer}
                onDelete={(userId) => {
                    props.handleDelete(userId)
                }}
            />}
            <Table responsive className="mb-0">
                <thead>
                    <tr>
                        <th width={35}>
                            <label className="st-checkbox st-checkbox-primary d-inline-flex cursor-pointer">
                                <input
                                    type="checkbox"
                                    className="d-none"
                                    checked={props.allCheckboxSelected}
                                    onChange={ev => props.handleSelectAllChange(ev)} />
                                <span className="box d-flex align-items-center justify-content-center border" style={{ height: 17, width: 17 }}>
                                    <FeatherIcon
                                        icon="check"
                                        size="11"
                                        className="icon position-relative" />
                                </span>
                            </label>
                        </th>
                        {
                            props.column__Customer && (
                                <th>
                                    <p className="text-capitalize">
                                        Customer
                                    </p>
                                </th>
                            )
                        }

                        {
                            props.column__Email && (
                                <th>
                                    <p className="text-capitalize">
                                        email
                                    </p>
                                </th>
                            )
                        }

                        {
                            props.column__Type && (
                                <th>
                                    <p className="text-capitalize">
                                        type
                                    </p>
                                </th>
                            )
                        }

                        {
                            props.column__TwoFactors && (
                                <th>
                                    <p className="text-capitalize">
                                        two factors
                                    </p>
                                </th>
                            )
                        }

                        {
                            props.column__LastActive && (
                                <th>
                                    <p className="text-capitalize">
                                        last active
                                    </p>
                                </th>
                            )
                        }

                        {
                            props.column__Status && (
                                <th>
                                    <p className="text-capitalize">
                                        status
                                    </p>
                                </th>
                            )
                        }
                        <th width="90"></th>
                    </tr>
                </thead>

                <tbody>
                    {
                        props.loading && (
                            <React.Fragment>
                                {
                                    (props.loadingCount && props.loadingCount.length) && props.loadingCount.map(item => (
                                        <React.Fragment key={item}>
                                            <CustomersLodingSkeleton />
                                        </React.Fragment>
                                    ))
                                }
                            </React.Fragment>
                        )
                    }

                    {
                        (props.customers && props.customers.length) ? props.customers.map((item, index) => (

                            <tr key={index} >
                                <td className="column__checkbox">
                                    <label className="st-checkbox st-checkbox-primary d-inline-flex cursor-pointer">
                                        <input type="checkbox" className="d-none all-checkboxes-selector-checkbox" />
                                        <span className="box d-flex align-items-center justify-content-center border" style={{ height: 17, width: 17 }}>
                                            <FeatherIcon
                                                icon="check"
                                                size="11"
                                                className="icon position-relative" />
                                        </span>
                                    </label>
                                </td>

                                {
                                    props.column__Customer && (
                                        <td className="column__customername">
                                            <Link to={{
                                                pathname: '/my-sales/customers/edit/' + item.user_id,
                                                state: { customerDetails: item }
                                            }} className="hover-underline-link st-text-primary">
                                                {item.first_name + " " + item.last_name}
                                            </Link>
                                        </td>
                                    )
                                }

                                {
                                    props.column__Email && (
                                        <td className="column__email">
                                            <p className="">
                                                {item.email}
                                            </p>
                                        </td>
                                    )
                                }

                                {
                                    props.column__Type && (
                                        <td className="column__type">
                                            <p className="st-text-primary">
                                                {item.customer_group || item.customer_group_name || item.group_name}
                                            </p>
                                        </td>
                                    )
                                }

                                {
                                    props.column__TwoFactors && (
                                        <td className="column__two-factors">
                                            <p className="text-capitalize">
                                                {item.enable_two_factor ? 'yes' : 'no'}
                                            </p>
                                        </td>
                                    )
                                }

                                {
                                    props.column__LastActive && (
                                        <td className="column__last-active">
                                            <p className="">
                                                <Moment
                                                    format="MMMM DD, YYYY hh:mm a"
                                                    date={item.last_login_time}
                                                />
                                            </p>
                                        </td>
                                    )
                                }

                                {
                                    props.column__Status && (
                                        <td className="column__status">
                                            <p className="text-capitalize">
                                                {item.customer_status === 1 ? 'active' : 'inactive'}
                                            </p>
                                        </td>
                                    )
                                }

                                <td className="column__actions">
                                    <div className="d-flex justify-content-end">
                                        {/* <OverlayTrigger
                                        placement={"left"}
                                        overlay={renderTooltipEdit}
                                    >
                                        <Link
                                            to={{
                                                pathname: '/my-sales/customers/edit/' + item.user_id,
                                                state: { customerDetails: item }
                                            }}
                                            className="st-round-btn st-btn-transparent st-btn-xs d-flex align-items-center justify-content-center me-1"
                                        >
                                            <FeatherIcon
                                                icon="edit-2"
                                                size="15"
                                                className="icon" />
                                        </Link>
                                    </OverlayTrigger> */}

                                        <OverlayTrigger
                                            placement={"left"}
                                            overlay={renderTooltipDelete}
                                        >
                                            <button
                                                className="st-round-btn st-btn-transparent st-btn-xs d-flex align-items-center justify-content-center"
                                                onClick={() => { setDeleteCustomer(item.user_id) }}
                                            >
                                                <FeatherIcon
                                                    icon="trash"
                                                    size="15"
                                                    className="icon" />
                                            </button>
                                        </OverlayTrigger>
                                    </div>
                                </td>
                            </tr>
                        )) : (
                            !props.loading ? (
                                <tr>
                                    <td colSpan="7">
                                        <p className="no-data-found text-center st-fw-700 py-1">
                                            no data found
                                        </p>
                                    </td>
                                </tr>
                            ) : null
                        )
                    }
                </tbody>
            </Table>
        </React.Fragment>
    )
}
